import Default from '../icons/Default.mjs';
import Cabana from '../icons/Cabana.mjs';
import Cash from '../icons/Cash.mjs';
import DoubleFunToken from '../icons/DoubleFunToken.mjs';
import EscapeToken from '../icons/EscapeToken.mjs';
import Food from '../icons/Food.mjs';
import GoldenToken from '../icons/GoldenToken.mjs';
import HotelToken from '../icons/HotelToken.mjs';
import Hotel from '../icons/Hotel.mjs';
import Monetization from '../icons/Monetization.mjs';
import Music from '../icons/Music.mjs';
import MysteryToken from '../icons/MysteryToken.mjs';
import SpaToken from '../icons/SpaToken.mjs';
import Spa from '../icons/Spa.mjs';
import Ticket from '../icons/Ticket.mjs';
import Trip from '../icons/Trip.mjs';

const iconTypes = {
  default: Default,
	cabana: Cabana,
	cash: Cash,
	doubleFunToken: DoubleFunToken,
	escapeToken: EscapeToken,
	food: Food,
	goldenToken: GoldenToken,
	hotelToken: HotelToken,
	hotel: Hotel,
	monetization: Monetization,
	music: Music,
	mysteryToken: MysteryToken,
	spaToken: SpaToken,
	spa: Spa,
	ticket: Ticket,
	trip: Trip,
};

const TokenIcon = ({ name, ...props }) => {
  let Icon = iconTypes[name];
	return <Icon {...props} />;
};

export default TokenIcon;
